export const correctUrl = (url: string) => {
  let urlToVisit = url;
  if (urlToVisit.indexOf('http') === -1) {
    urlToVisit = 'https://' + urlToVisit;
  }
  return urlToVisit;
};
